import React from 'react';
import { css, Flex, Box, Icon, Text, styled } from '@goodrx/matisse';

import { FocusOn } from 'react-focus-on';
import { mediaMaxWidth, mediaMinWidth } from 'app/lib/utils';

const DrawerBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 6;
  background: rgba(0, 0, 0, 0.2);
`;

interface DrawerContainerStyleProps {
  isOpen?: boolean;
}

const DrawerContainer = styled.div<DrawerContainerStyleProps>(
  (p) => css`
    position: fixed;
    background: white;
    transition: 250ms ease;
    z-index: 12;
    top: 0px;
    right: 0px;
    bottom: 0px;
    max-width: 500px;
    transform: translateX(500px);
    z-index: 999;
    overflow: hidden;

    ${mediaMaxWidth({
      md: css`
        width: 100vw;
        transform: translateX(100vw);
      `,
    })}

    ${p.isOpen &&
    css`
      transform: translateX(0) !important;
    `}
  `
);

const DrawerBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  width: 100%;
`;

const DrawerHeader = styled.header(
  (p) => css`
    border-bottom: 1px solid ${p.theme.colors.greyLight};
    padding-bottom: ${p.theme.space[3]}px;
    margin: ${p.theme.space[3]}px ${p.theme.space[3]}px 0px ${p.theme.space[3]}px;

    ${mediaMinWidth({
      md: css`
        margin: ${p.theme.space[4]}px ${p.theme.space[5]}px 0px ${p.theme.space[5]}px;
      `,
    })}
  `
);

interface DrawerProps {
  isOpen?: boolean;
  headerText?: string;
  onClose?: () => void;
  renderHeader?: () => any;
}

export const Drawer: React.FC<DrawerProps> = ({ children, isOpen, onClose, headerText, renderHeader }) => (
  <FocusOn onEscapeKey={onClose} enabled={isOpen} noIsolation>
    <DrawerContainer isOpen={isOpen}>
      <DrawerBody>
        {typeof renderHeader === 'function' ? (
          renderHeader()
        ) : (
          <DrawerHeader>
            <Flex alignItems="center">
              <Text fontWeight={500} fontSize={22} fontFamily="Tiempos">
                {headerText}
              </Text>
              <Box flex={1} />
              <Icon name="close" onClick={onClose} size={24} />
            </Flex>
          </DrawerHeader>
        )}

        {isOpen && <DrawerBody>{children}</DrawerBody>}
      </DrawerBody>
    </DrawerContainer>
    {isOpen && <DrawerBackdrop onClick={onClose} />}
  </FocusOn>
);
